import { render, staticRenderFns } from "./cartOrderSubmit.vue?vue&type=template&id=051c42d2&scoped=true&"
import script from "./cartOrderSubmit.vue?vue&type=script&lang=js&"
export * from "./cartOrderSubmit.vue?vue&type=script&lang=js&"
import style0 from "./cartOrderSubmit.vue?vue&type=style&index=0&id=051c42d2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "051c42d2",
  null
  
)

export default component.exports